import { MergeLinkOrganizationCustomizationData } from "../config/types";

const fontToCssMapping: { [key: string]: string } = {
  Arial: "Arial, sans-serif",
  "Arial Black": "'Arial Black', Gadget, sans-serif",
  "Courier New": "'Courier New', Courier, monospace",
  Georgia: "Georgia, serif",
  Helvetica: "Helvetica, sans-serif",
  "Lucida Sans": "'Lucida Sans', 'Lucida Grande', 'Lucida Sans Unicode', sans-serif",
  Palatino: "Palatino, 'Palatino Linotype', serif",
  Tahoma: "Tahoma, Geneva, sans-serif",
  "Times New Roman": "'Times New Roman', Times, serif",
  "Trebuchet MS": "'Trebuchet MS', Helvetica, sans-serif",
  Verdana: "Verdana, Geneva, sans-serif",
  "Lucida Console": "'Lucida Console', Monaco, monospace",
  "Comic Sans MS": "'Comic Sans MS', cursive, sans-serif",
  Roboto: "'Roboto', sans-serif",
  "System UI": "system-ui, -apple-system, BlinkMacSystemFont, 'Inter', sans-serif",
  "Open Sans": "'Open Sans', sans-serif",
  Lato: "'Lato', sans-serif",
  Montserrat: "'Montserrat', sans-serif",
  Poppins: "'Poppins', sans-serif",
  Nunito: "'Nunito', sans-serif",
  Raleway: "'Raleway', sans-serif",
  "Source Sans 3": "'Source Sans 3', sans-serif",
  "Playfair Display": "'Playfair Display', serif",
};

export function getCssFontFamily(fontName: string | null) {
  if (!fontName) {
    return null;
  }
  return fontToCssMapping[fontName] || null;
}


/**
 * Layers a payload's org customization over what earlier payloads supplied.
 *
 * Fields are merged individually, and null or absent values are ignored, because
 * later payloads in a linking flow often carry a partial customization (or none at
 * all). Replacing wholesale would drop the cobranding logo partway through the flow.
 */
export function mergeOrgCustomization(
  previous: MergeLinkOrganizationCustomizationData | null,
  next: MergeLinkOrganizationCustomizationData
): MergeLinkOrganizationCustomizationData {
  const definedFields = Object.fromEntries(
    Object.entries(next).filter(([, value]) => value !== null && value !== undefined)
  ) as Partial<MergeLinkOrganizationCustomizationData>;

  return { ...previous, ...definedFields } as MergeLinkOrganizationCustomizationData;
}
